module.exports = __webpack_public_path__ + "img/double-page-spread.4048446.svg";